import { Navigate, Route, Routes } from 'react-router-dom';

import GenericError from '@/components/pages/GenericError/GenericError';

import ChatPage from '../components/pages/ChatPage/ChatPage';
import IframeTestPage from '../components/pages/IframeTestPage/IframeTestPage';
import routes from '../routes/routes';
import AppLayout from './AppLayout';

const isIframeTestRouteEnabled = import.meta.env.VITE_FEATURE_FLAG_IFRAME_TEST_ROUTE_ENABLED;

const App = () => (
    <Routes>
        <Route path={routes.error} element={<GenericError />} />

        <Route path="" element={<AppLayout />}>
            <Route index element={<Navigate to="/" replace />} />

            <Route path={routes.chat} element={<ChatPage />}/>
            <Route path={routes.others} element={<ChatPage />}/>

            {isIframeTestRouteEnabled && (
                <Route path={routes.iframeTest} element={<IframeTestPage />}/>
            )}
            <Route path="*" element={<ChatPage />} />
        </Route>
    </Routes>
);

export default App;
